<template>
  <el-dialog 
    :title="$t('addService.addService')" 
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose">
    <el-form :model="addServiceInfo" :rules="rules" ref="addServiceForm" label-width="120px">
      <el-form-item :label="$t('addService.serviceName')" prop="name">
        <el-input 
          v-model="addServiceInfo.name" 
          :placeholder="$t('addService.enterServiceName')"
          clearable>
        </el-input>
      </el-form-item>
      
      <el-form-item :label="$t('addService.serviceCode')" prop="serviceCode">
        <el-input 
          v-model="addServiceInfo.serviceCode" 
          :placeholder="$t('addService.enterServiceCode')"
          clearable>
        </el-input>
      </el-form-item>
      
      <el-form-item :label="$t('addService.serviceUrl')" prop="url">
        <el-select 
          v-model="addServiceInfo.url" 
          :placeholder="$t('addService.selectServiceUrl')"
          style="width:100%">
          <el-option 
            v-for="(item,index) in addServiceInfo.services" 
            :key="index"
            :label="item.name"
            :value="item.statusCd">
          </el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item :label="$t('addService.serviceMethod')" prop="method">
        <el-select 
          v-model="addServiceInfo.method" 
          :placeholder="$t('addService.selectServiceMethod')"
          style="width:100%">
          <el-option value="GET" label="http get"></el-option>
          <el-option value="POST" label="http post"></el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item :label="$t('addService.timeout')" prop="timeout">
        <el-input 
          v-model="addServiceInfo.timeout" 
          :placeholder="$t('addService.enterTimeout')"
          clearable>
        </el-input>
      </el-form-item>
      
      <el-form-item :label="$t('addService.retryCount')" prop="retryCount">
        <el-input 
          v-model="addServiceInfo.retryCount" 
          :placeholder="$t('addService.enterRetryCount')"
          clearable>
        </el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveServiceInfo">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { saveService } from '@/api/dev/serviceManage/serviceManageApi'

export default {
  name: 'AddService',
  data() {
    return {
      dialogVisible: false,
      addServiceInfo: {
        name: '',
        serviceCode: '',
        businessTypeCd: 'API',
        seq: '1',
        messageQueueName: '',
        isInstance: 'CMD',
        url: 'http://iot-community',
        method: '',
        timeout: '60',
        retryCount: '3',
        provideAppId: '8000418002',
        services: []
      },
      rules: {
        name: [
          { required: true, message: this.$t('addService.serviceNameRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('addService.serviceNameMaxLength'), trigger: 'blur' }
        ],
        serviceCode: [
          { required: true, message: this.$t('addService.serviceCodeRequired'), trigger: 'blur' },
          { min: 2, max: 100, message: this.$t('addService.serviceCodeLength'), trigger: 'blur' }
        ],
        method: [
          { required: true, message: this.$t('addService.methodRequired'), trigger: 'change' }
        ],
        timeout: [
          { required: true, message: this.$t('addService.timeoutRequired'), trigger: 'blur' },
          { pattern: /^\d+$/, message: this.$t('addService.timeoutNumber'), trigger: 'blur' }
        ],
        retryCount: [
          { required: true, message: this.$t('addService.retryCountRequired'), trigger: 'blur' },
          { pattern: /^\d+$/, message: this.$t('addService.retryCountNumber'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.getDictData()
    },
    async getDictData() {
      try {
        const {data} = await getDict('c_service', 'url')
        this.addServiceInfo.services = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleClose() {
      this.$refs.addServiceForm.resetFields()
      this.addServiceInfo = {
        name: '',
        serviceCode: '',
        businessTypeCd: 'API',
        seq: '1',
        messageQueueName: '',
        isInstance: 'CMD',
        url: 'http://iot-community',
        method: '',
        timeout: '60',
        retryCount: '3',
        provideAppId: '8000418002',
        services: []
      }
    },
    saveServiceInfo() {
      this.$refs.addServiceForm.validate(async valid => {
        if (valid) {
          try {
            await saveService(this.addServiceInfo)
            this.$message.success(this.$t('addService.saveSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          } catch (error) {
            console.error('保存服务失败:', error)
          }
        }
      })
    }
  }
}
</script>